import styled from 'styled-components';
import { getThemeColor } from 'utils/styled';
import { TAB_TRANSITION } from '../constants';
import { ICON_CLASS_NAME } from './constants';
import { ContentsStyleProps } from './types';

export const Tab = styled.div`
  flex: 1 1 0;
  outline: none;
  color: ${getThemeColor('actionTertiary')};
  cursor: pointer;
  transition: ${TAB_TRANSITION};

  &[aria-selected='true'] {
    color: ${getThemeColor('actionPrimary')};
  }

  &[aria-disabled='true'] {
    cursor: not-allowed;
  }

  &[data-hovered='true']:not([aria-selected='true']):not([aria-disabled='true']) {
    color: ${getThemeColor('l4')};
  }
`;

export const Contents = styled.div<ContentsStyleProps>`
  ${({ theme }) => theme.typography.variants.button.default};

  display: flex;
  flex-direction: ${({ $iconPosition }) =>
    $iconPosition === 'top' ? 'column' : 'row'};
  align-items: center;
  justify-content: center;
  padding-bottom: ${({ theme }) => theme.spacing.create(2)};
  opacity: ${({ $disabled }) => ($disabled ? 0.3 : 1)};

  & > .${ICON_CLASS_NAME} {
    ${({ $iconPosition, theme }) => {
      const margin = theme.spacing.create(1);

      switch ($iconPosition) {
        case 'left':
          return `
            margin-right: ${margin};
          `;

        case 'top':
          return `
            margin-bottom: ${margin};
          `;

        default:
          return undefined;
      }
    }}
  }
`;
